import { render, staticRenderFns } from "./orgImportTable.vue?vue&type=template&id=2bb1ad80&"
import script from "./orgImportTable.vue?vue&type=script&lang=ts&"
export * from "./orgImportTable.vue?vue&type=script&lang=ts&"
import style0 from "./orgImportTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports